import React, { Component } from "react";
export default class ContactUs extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="contact">
        <div className="row section-head">
          <div className="ten columns">
            <p className="lead">
              Feel free to contact me for any work or suggestions using below
              information
            </p>
          </div>
        </div>
        <div className="row">
          <aside className="eigth columns footer-widgets">
            <div className="widget">
              <h4>
                <a href={resumeData.linkedinId}>Linked In</a>
              </h4>
              <h4>
                <a href="mailto:mariustoporascu@yahoo.com">Yahoo</a>
              </h4>
              <h4>
                <span>Mobile No: +40 725 135 824</span>
              </h4>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}
